export default class Utils {
    static renderTagLabel(tag) {
        if(tag.document && tag.document[0] && tag.document[0].data && tag.document[0].data.label)
        {
            return tag.document[0].data.label
        } else {
            return tag.slug
        }
    }
}